module.exports = __webpack_public_path__ + "img/ic_additional_documents.e6b9ed90.svg";